import ScreenArea from './screen-area.vue';
export default ScreenArea;